var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',[_vm._v(_vm._s(_vm.$t('categories')))]),_c('ul',[_c('li',[_vm._v(_vm._s(_vm.$t('all')))]),_c('li',[_vm._v(_vm._s(_vm.$t('all')))]),_c('li',[_vm._v(_vm._s(_vm.$t('all')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }